// DevEditorPane.js — Zone éditeur (sans chrome redondant)

import React from 'react';
import { FileCode2 } from 'lucide-react';
import './devCockpit.css';

export default function DevEditorPane({ children }) {
    return (
        <div className="dev-editor-pane">
            {children}
        </div>
    );
}

export function DevEditorEmpty() {
    return (
        <div className="dev-editor-pane__empty">
            <div className="dev-editor-pane__empty-icon">
                <FileCode2 size={20} />
            </div>
            <span>Sélectionnez un fichier dans l&apos;explorateur</span>
        </div>
    );
}

export function DevEditorLoading({ label = 'Chargement…' }) {
    return (
        <div className="dev-editor-pane__empty">
            <span className="dev-editor-pane__spinner" />
            <span>{label}</span>
        </div>
    );
}
